import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {formatDate, formatDateTime, useIsMobile} from "../../../../../_common/function";
import {Badge, Col, List, Modal, Row, Tag, Typography} from "antd";
import VirtualList from "rc-virtual-list";
import EmptyData from "../../../../../../brand/component/emptyData/view";
import Loader from "../../../../../../brand/component/loader/view";
import {updateUserAnnouncementReadStatus} from "../../../../../api/graphql/announcement";
import {useSetRecoilState} from "recoil";
import {globalUnreadAnnouncementCountState} from "../../../../../_common/global_state";

const {Paragraph} = Typography

// the cap the list scrolls within; fullHeight={false} makes it a max-height, so a
// short list hugs its rows instead of reserving the whole 400px
const CONTAINER_HEIGHT = 400;

const AnnouncementListing_2 = (props) => {
    const {
        isHeader,
        data,
        loading,
    } = props
    const isMobile = useIsMobile();
    const {t} = useTranslation();

    const [selected, setSelected] = useState({})
    const [modalOpen, setModalOpen] = useState(false);
    const [currentData, setCurrentData] = useState({})
    const [updatedRead, setUpdatedRead] = useState([])

    const setUnreadAnnouncementCount = useSetRecoilState(globalUnreadAnnouncementCountState);

    const renderTinyMCEContent = (content) => (
        <div className={"tinyMceParagraph"} dangerouslySetInnerHTML={{__html: content}}/>
    )

    const selectItem = () => {
        setSelected({})
    }

    // useEffect(() => {
    //     if (!!data?.length) {
    //         if (!isMobile) {
    //             selectItem(data?.[0]);
    //         }
    //     } else {
    //         setSelected([]);
    //     }
    // }, [data])

    const loadingComponent = <>
        <Col span={24} className={"mb-6"}>
            <div className={"flex items-center justify-center min-h-[400px]"}>
                <Loader/>
            </div>
        </Col>
    </>

    const dateToday = formatDate(new Date(), true, "YYYY-MM-DD")

    const listComponent = (
        <List>
            <VirtualList
                className={"cursor-pointer"}
                data={data}
                height={CONTAINER_HEIGHT}
                fullHeight={false}
                itemHeight={47}
                itemKey={"_id"}
            >
                {(item) => {
                    const title = item?.dataOfObject?.title
                    const description = item?.dataOfObject?.description
                    const time = item?.createdAt
                    const isToday = formatDate(time, true, "YYYY-MM-DD") === dateToday
                    const isUnread = !item?.isRead && !updatedRead.includes(item?._id)
                    const isUpdated = item?.isAnnouncementUpdated && !updatedRead.includes(item?._id)
                    // a record can arrive with an empty payload — promote the description to the
                    // heading rather than drawing a row with nothing in it, and fall back to a
                    // label only when both are missing
                    const heading = title || description || t("announcement.untitled", {defaultValue: "Untitled announcement"})
                    const body = title ? description : null

                    const openItem = async () => {
                        if (isHeader) {
                            setCurrentData(item)
                            setModalOpen(true);
                            if (isUnread) {
                                const res = await updateUserAnnouncementReadStatus([item?._id], true)
                                if (res?.updateUserAnnouncementReadStatus[0]?.isRead) {
                                    setUpdatedRead(prev => [...prev, res?.updateUserAnnouncementReadStatus[0]?._id])
                                    setUnreadAnnouncementCount(prev => prev - 1)
                                }
                            } else if (isUpdated) {
                                const res = await updateUserAnnouncementReadStatus([item?._id], true)
                                setUpdatedRead(prev => [...prev, res?.updateUserAnnouncementReadStatus[0]?._id])
                            }
                        } else {
                            selectItem()
                        }
                    }

                    return (
                        <div
                            key={item?._id}
                            role={"button"}
                            tabIndex={0}
                            className={"text-start announcement-card" + (isUnread ? " is-unread" : "")}
                            onClick={openItem}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault()
                                    openItem()
                                }
                            }}
                        >
                            <Row wrap={false} align={"middle"} gutter={8}>
                                {isUnread && (
                                    <Col flex={"none"} className={"unread-dot"}>
                                        <Badge dot/>
                                    </Col>
                                )}
                                <Col flex={"auto"}>
                                    <Paragraph className={"title"} ellipsis>
                                        {heading}
                                    </Paragraph>
                                </Col>
                                <Col flex={"none"} className={"text-end date-time"}>
                                    {formatDateTime(time, isToday ? "hh:mm A" : "DD/MM, hh:mm A")}
                                </Col>
                            </Row>
                            {(body || isUpdated) && (
                                <Row wrap={false} align={"middle"} gutter={8}>
                                    {body && (
                                        <Col flex={"auto"}>
                                            <Paragraph ellipsis={{rows: 2}} className={"description"}>
                                                {body}
                                            </Paragraph>
                                        </Col>
                                    )}
                                    {isUpdated && (
                                        <Col flex={"none"}>
                                            <Tag className={"announcement-updated-tag"} color="processing">
                                                Updated
                                            </Tag>
                                        </Col>
                                    )}
                                </Row>
                            )}
                        </div>
                    )
                }}
            </VirtualList>
        </List>
    )

    const emptyComponent = (
        <div className={"mx-auto mt-6"}>
            <EmptyData/>
        </div>
    )

    return (
        <div id={"announcementListing"}>
            {loading ? loadingComponent : !!data?.length ? listComponent : emptyComponent}
            <Modal
                title={
                    <>
                        {currentData?.dataOfObject?.title
                            || currentData?.dataOfObject?.description
                            || t("announcement.untitled", {defaultValue: "Untitled announcement"})}
                        <p className={"date-time"}>
                            {formatDateTime(currentData?.createdAt, "MMMM Do YYYY, h:mm:ss a")}
                            {currentData?.announcementUpdatedAt && ` (Last updated on ${formatDateTime(currentData?.announcementUpdatedAt, "MMMM Do YYYY, h:mm:ss a")})`}
                        </p>
                    </>
                }
                width={isMobile ? "90%" : "60%"}
                open={modalOpen}
                footer={null}
                onCancel={() => setModalOpen(false)}
                className={"announcement-modal"}
                getContainer={() => document.querySelector("#layout-2")}
            >
                {currentData?.dataOfObject?.title && currentData?.dataOfObject?.description && (
                    <p>{currentData?.dataOfObject?.description}</p>
                )}
                {currentData?.dataOfObject?.content ? (
                    <div className={"mt-4"}>{renderTinyMCEContent(currentData?.dataOfObject?.content)}</div>
                ) : !currentData?.dataOfObject?.description ? (
                    <p className={"description"}>
                        {t("announcement.noContent", {defaultValue: "This announcement has no content."})}
                    </p>
                ) : null}
            </Modal>
        </div>
    )
};

export default AnnouncementListing_2;